import styled from 'styled-components';

const getRedListBorder = (color) => {
  if (color === '#FFFFFF') {
    return '1px solid #202020'
  }

  if (color === 'rgb(255, 255, 255)') {
    return '1px solid rgba(32, 32, 32, 0.2)'
  }

  return 'none'
}

const getRedListTextColor = (color) => {
  if (color === '#202020') {
    return '#FFF'
  }

  return '#202020'
}

export const RedListCategoryStatus = styled.div`
  width: 32px;
  height: 24px;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  padding: 4px 8px 4px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: ${(p) => getRedListBorder(p.color)};
  color: ${(p) => getRedListTextColor(p.color)};
  background-color: ${(p) => {
    return p.color
  }};
`;

export const StyledCalculationTable = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  border-bottom-left-radius: 14px;
  border-bottom-right-radius: 14px;
  -webkit-overflow-scrolling: touch;
  scrollbar-gutter: stable both-edges;

  &::-webkit-scrollbar {
    height: 10px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(32, 32, 32, 0.05);
    border-radius: 999px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(32, 32, 32, 0.22);
    border-radius: 999px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(32, 32, 32, 0.32);
  }

  .scroll {
    max-height: none;
    overflow-x: auto;
    overflow-y: visible;
    -webkit-overflow-scrolling: touch;
  }

  table {
    width: max-content;
    min-width: 100%;
    table-layout: auto;
    border-collapse: separate;
    border-spacing: 0;

    th {
      position: sticky;
      top: 0;
      z-index: 1;
      background: linear-gradient(180deg, rgba(248, 249, 250, 1) 0%, rgba(255, 255, 255, 1) 100%);
      color: rgba(32, 32, 32, 0.72);
      font-size: 13px;
      font-weight: 600;
      letter-spacing: 0.01em;
      border-bottom: 1px solid rgba(32, 32, 32, 0.08);
      white-space: nowrap;
      padding: 12px 16px;
    }

    td {
      border-bottom: 1px solid rgba(32, 32, 32, 0.06);
      vertical-align: middle;
      white-space: nowrap;
      font-size: 14px;
      line-height: 20px;
      padding: 12px 16px;

      :last-child {
        border-left: 1px solid rgba(32, 32, 32, 0.08);
        text-align: right;
        padding-right: 16px;
        font-weight: 400;
      }

      :nth-child(2) {
        background: rgba(32, 32, 32, 0.018);
      }
    }

    tbody tr:nth-child(even) td {
      background: rgba(32, 32, 32, 0.012);
    }

    tbody tr:hover td {
      background: rgba(29, 78, 216, 0.035);
    }

    @media (max-width: 900px) {
      th,
      td {
        padding: 10px 12px;
      }

      th {
        font-size: 12px;
      }

      td {
        font-size: 13px;
        line-height: 18px;
      }
    }
  }
`;

export const StyledCalculationTableEco = styled.div`
  width: 100%;
  overflow-x: auto;
  border: 1px solid rgba(32, 32, 32, 0.08);
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(32, 32, 32, 0.04);
  -webkit-overflow-scrolling: touch;
  scrollbar-gutter: stable both-edges;

  &::-webkit-scrollbar {
    height: 10px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(32, 32, 32, 0.05);
    border-radius: 999px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(32, 32, 32, 0.22);
    border-radius: 999px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(32, 32, 32, 0.32);
  }

  table {
    width: max-content;
    min-width: 100%;
    table-layout: auto;
    border-collapse: separate;
    border-spacing: 0;

    th {
      background: linear-gradient(180deg, rgba(248, 249, 250, 1) 0%, rgba(255, 255, 255, 1) 100%);
      color: rgba(32, 32, 32, 0.72);
      font-size: 12px;
      font-weight: 600;
      border-bottom: 1px solid rgba(32, 32, 32, 0.08);
      white-space: normal;
      word-break: break-word;
      padding-top: 8px;
      padding-bottom: 8px;
    }

    td {
      border-bottom: 1px solid rgba(32, 32, 32, 0.06);
      vertical-align: middle;
      white-space: normal;
      word-break: break-word;
      padding-top: 9px;
      padding-bottom: 9px;

      :last-child {
        border-left: 1px solid rgba(32, 32, 32, 0.08);
        text-align: right;
        padding-right: 14px;
        font-weight: 400;
      }
    }

    tbody tr:nth-child(even) td {
      background: rgba(32, 32, 32, 0.012);
    }

    tbody tr:hover td {
      background: rgba(29, 78, 216, 0.035);
    }

    @media (max-width: 900px) {
      th,
      td {
        padding-left: 12px;
        padding-right: 12px;
      }

      td {
        font-size: 13px;
        line-height: 18px;
      }
    }
  }
`;

export const FullWidthCalculationSection = styled.div`
  width: calc(100vw - 48px);
  max-width: 1760px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  overflow: visible;

  @media (max-width: 1600px) {
    width: calc(100vw - 32px);
  }

  @media (max-width: 900px) {
    width: calc(100vw - 24px);
  }

  @media (max-width: 640px) {
    width: calc(100vw - 16px);
  }
`;

export const SpeciesPaginationWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  padding: 16px 4px 8px;

  @media (max-width: 640px) {
    gap: 12px;
    padding-top: 14px;
  }
`;

export const TableNotQualifyIconWrapper = styled.div`  
  height: 24px;
  width: 24px;  
  margin-left: auto;

`;

export const StyledTooltip = styled.div`
  display: inline-block;
`;
